import { Controller } from "@hotwired/stimulus"

// Keeps the project name in step with the brand name until the user types a
// different one. Clearing the project name makes it follow the brand again.
export default class extends Controller {
  static targets = ["brand", "name"]

  connect() {
    const name = this.nameTarget.value.trim()
    this.customized = name !== "" && name !== this.brandTarget.value.trim()
  }

  sync() {
    if (!this.customized) this.nameTarget.value = this.brandTarget.value
  }

  customize() {
    const name = this.nameTarget.value.trim()
    this.customized = name !== "" && name !== this.brandTarget.value.trim()
  }
}
